<template>
  <button
    v-if="qonfiData"
    type="button"
    :class="[$props.class]"
    v-bind="qonfiData"
  >
    <slot />
    <LazyThirdpartyQonfi />
  </button>
  <button
    v-else-if="goTo.endsWith('#chat')"
    type="button"
    @click="startChat"
  >
    <slot />
  </button>
  <NuxtLink
    v-else
    v-bind="linkProps"
  >
    <slot>{{ goTo }}</slot>
  </NuxtLink>
</template>

<script lang="ts" setup>
const { locale } = useI18n()

const props = defineProps({
  to: {
    type: [String, Object],
    default: undefined,
  },
  href: {
    type: String,
    default: undefined,
  },
  target: {
    type: String,
    default: undefined,
  },
  rel: {
    type: String,
    default: undefined,
  },
  noRel: {
    type: Boolean,
    default: false,
  },
  replace: {
    type: Boolean,
    default: false,
  },
  external: {
    type: Boolean,
    default: undefined,
  },
  custom: {
    type: Boolean,
    default: undefined,
  },
  prefetch: {
    type: Boolean,
    default: undefined,
  },
  noPrefetch: {
    type: Boolean,
    default: undefined,
  },
  activeClass: {
    type: String,
    default: undefined,
  },
  exactActiveClass: {
    type: String,
    default: undefined,
  },
  ariaCurrentValue: {
    type: String,
    default: undefined,
  },
  prefetchedClass: {
    type: String,
    default: undefined,
  },
})

const qonfiData = computed(() => {
  if (typeof to?.value === 'object') {
    return null
  }
  if (to?.value?.includes('qonfi-advisor-id:')) {
    return {
      'data-qonfi-uuid': to.value.replace('qonfi-advisor-id:', ''),
      'data-qonfi-view-type': 'popup',
      'data-qonfi-lang': locale.value.toUpperCase(),
    }
  }
  if (to?.value?.includes('data-qonfi-uuid=')) {
    const params = new URLSearchParams(to.value)
    return Object.fromEntries(params.entries())
  }
  return null
})

const { to, href } = toRefs(props)

const { sanitizeUrl } = useSanitizeUrl()
const goTo = computed(() => {
  if (typeof to.value === 'object') {
    const router = useRouter()
    return sanitizeUrl(router.resolve(to.value).href)
  }

  return sanitizeUrl(to?.value || href?.value || '')
})

const { triggerChat } = useChat()

const startChat = () => {
  triggerChat.value = true
}

const linkProps = computed(() => {
  const linkProps: any = {
    ...props,
    // to: props.to || props.href,
    // rel: props.rel,
    // noRel: props.noRel,
    // target: props.target,
    // external: props.external,
  }

  linkProps.to = goTo.value

  if (linkProps.rel) {
    linkProps.rel = linkProps.rel || goTo.value?.includes('http') ? 'noopener noreferrer' : undefined
  }

  linkProps.target = linkProps.target || goTo.value?.includes('http') ? '_blank' : undefined
  linkProps.external = linkProps.external || goTo.value?.includes('http')

  // delete linkProps.href
  linkProps.href = undefined

  if (linkProps.noRel) {
    linkProps.rel = undefined
    // delete linkProps.rel
  }

  // for (const prop in linkProps) {
  //   if (linkProps[prop] === undefined) {
  //     delete linkProps[prop]
  //   }
  // }

  return linkProps
})
</script>
